import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface SellDecisionNoticeProps {
    note?: string | null;
}

export function SellDecisionNotice({ note }: SellDecisionNoticeProps) {
    return (
        <div className="mt-2 flex gap-2 rounded-xl border border-amber-200 bg-amber-50 p-3">
            <InformationCircleIcon
                className="h-4 w-4 shrink-0 text-amber-600"
                aria-hidden="true"
            />
            <p className="text-xs text-amber-900 font-montserrat whitespace-pre-line">
                <span className="font-semibold">Férias aprovadas, abono reprovado.</span> O abono de 1/3 das férias não foi aprovado pelo DP{note ? `: ${note}` : '.'} Esses dias retornam
                ao seu saldo e podem ser usados em outra solicitação.
            </p>
        </div>
    );
}

export default SellDecisionNotice;
